module.exports = __webpack_public_path__ + "media/images/countryrect/ly-23b62c434312d7e1fc9aef594a4cd1bf.svg";